import DeliveryNoteSearchForm from '../components/orders/delivery-note-search-form';
import Table from '../components/shared/table';
import SearchForm from '../model/search-form';
import { formatDate } from '../helpers/utils';
import HTMLTemplateHelper from '../helpers/html-template-helper';
import MessageHelper from '../helpers/message-helper';
import AbstractAsyncTablePage from './abstract-async-table-page';
import ShippingOrderData from '../model/shipping-order-data';

export default class ShippingOrderOverviewPage extends AbstractAsyncTablePage {
  private readonly printButton: JQuery;
  private readonly documentCheckboxes: JQuery;
  private selectedDocuments: string[] = [];
  protected readonly searchForm: SearchForm;
  protected readonly table: Table;
  protected readonly tableColumnDefinitions: DataTables.ColumnDefsSettings[] = [
    {
      targets: 0,
      data: (data: ShippingOrderData, type: string): string | number => {
        if (data.dateCreated === null) {
          return 0;
        }
        if (type === 'sort') {
          return data.dateCreated;
        }
        return formatDate(new Date(data.dateCreated));
      },
    },
    { targets: 1, data: 'shippingOrderNumber' },
    { targets: 2, data: 'orderingPartyId' },
    { targets: 3, data: 'orderingPartyName' },
    { targets: 4, data: 'billRecipient' },
    { targets: 5, data: 'billRecipientName' },
    { targets: 6, data: 'shipToPartyId' },
    { targets: 7, data: 'shipToPartyName' },
    { targets: 8, data: 'formattedDeliveryCost' },
    {
      targets: 9,
      className: 'text-align-center',
      data: (data: ShippingOrderData): string => HTMLTemplateHelper.createLinkButton({
        buttonClass: '-clear -compact',
        href: `${window.ACC.config.encodedContextPath}/shippingOrders/print?token=${data.fileDownloadJwt}`,
        text: MessageHelper.getMessage('common.print'),
        textClass: 'sr-only',
        icon: 'fas fa-file-download',
      }).outerHTML,
    },
  ];

  constructor(body: JQuery) {
    super();

    this.printButton = body.find('.js-shippingOrderPrintButton');
    this.documentCheckboxes = body.find('.js-documentCheckbox');
    this.searchForm = new DeliveryNoteSearchForm(body.find('.js-shippingOrdersForm') as JQuery<HTMLFormElement>);
    this.table = new Table(body.find('.js-table'), this.tableColumnDefinitions);
    this.bindAsyncData();
  }

  init(): void {
    super.init();
    this.bindPrint();
    this.bindCheckboxChange();
  }

  bindCheckboxChange(): void {
    this.documentCheckboxes.on('change', () => {
      this.documentCheckboxes.each(() => {
        this.printButton.prop('disabled', !this.documentCheckboxes.is(':checked'));
      });
    });
  }

  bindPrint(): void {
    this.printButton.on('click', () => {
      this.fetchAllSelectedDocuments();
      this.selectedDocuments.forEach((id) => {
        setTimeout(() => {
          window.open(`/shippingOrders/${id}/print`);
        }, 1000);
      });

      this.selectedDocuments = [];
      this.uncheckAllCheckboxes();
    });
  }

  fetchAllSelectedDocuments(): void {
    this.documentCheckboxes.each((i, element) => {
      if ($(element).is(':checked')) this.selectedDocuments.push($(element).data('document-id'));
    });
  }

  uncheckAllCheckboxes(): void {
    this.documentCheckboxes.each((i, element) => {
      if ($(element).is(':checked')) $(element).prop('checked', false);
    });
    this.printButton.prop('disabled', true);
  }

}
